import { usePlatform } from "@portal/hooks/usePlatform";
import { FC } from "react";
import { cn } from "../lib/utils";
import { BaseComponentProps } from "../types";
import { baseAttrs } from "../utils";

export type HotkeyTagProps = BaseComponentProps & {
	hotkey: string;
};

export const HotkeyTag: FC<HotkeyTagProps> = ({ id, testId, trackingId, hotkey, className }) => {
	const { isMac } = usePlatform();

	return (
		<span
			{...baseAttrs({
				id,
				testId,
				trackingId,
				className: cn(
					"text-xs text-tertiary bg-surface-light rounded px-1.5 py-0.5 border border-bc-default font-mono",
					className,
				),
			})}
		>
			{`${isMac ? "⌘" : "Ctrl+"}${hotkey}`}
		</span>
	);
};
